'use client';

import Skeleton from '@mui/material/Skeleton';

// The heading line that sits at the top of a content section — shared so every
// page skeleton's section titles have the same size and rhythm.
export function SectionHeadingSkeleton({width = 220}: {width?: number}) {
  return <Skeleton variant="text" animation="wave" width={width} sx={{fontSize: theme => theme.font.size['title-3'], mb: 3}} />;
}

SectionHeadingSkeleton.displayName = 'SectionHeadingSkeleton';
